// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSciencePlantPotSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.938 2c2.973 0 4.921 1.852 5.663 4.466C13.603 5.504 15.06 5 16.938 5h3c.552 0 1.01.45.926.997C20.372 9.23 17.459 11 13.938 11H13v2h6.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H18v4a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3v-4H4.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H11v-2.44a.608.608 0 0 1 0-.06V9H9.938a7.002 7.002 0 0 1-6.93-6.003C2.932 2.45 3.387 2 3.939 2z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSciencePlantPotSolid;
